import React from 'react';
import Uganda_p1 from './uganda_p1';

import Uganda_p1_subjects from './uganda_p1_subjects';

const Uganda_p1math = () => {
  return (
    <>
    <Uganda_p1 />
    <Uganda_p1_subjects />
    <div className='relative right-0 left-0 top-37 '>
      <h1> Mathematics</h1>
      <h3>Math content</h3>
      <li>Generic skills or Soft skills or 21st century skills integrated in Math learning and assessment </li>
      <li>Cross-cutting isues integrated in Math learning and assessment </li>
      <li>Values integrated in Math learning and assessment </li>
    </div>
    </>
  );
}

export default Uganda_p1math;
